import Service from "./service";

class ListingCalendarService extends Service {

  constructor(unauthorized=true) {
    super("LISTING_CALENDAR_SERVICE", unauthorized);
  }

  requestOTP = (email, issuer) => {
    return this.unauthenticatedPost(`/otp/request`, {},  {
      email: email,
      issuer: issuer
    });
  }

  verifyOTP = (email, issuer, otp) => {
    return this.unauthenticatedPost(`/otp/verify`, {},  {
      email: email,
      issuer: issuer,
      otp: otp
    });
  }

  unAuthGetReservation = () => {
    return this.unauthenticatedGet(`/reservation/request/unauth-user`,
      {},
      {}
    );
  }

  unAuthRequestReservation = (data) => {
    return this.unauthenticatedPost(`/reservation/request`, 
      {}, 
      data);
  }

  unAuthTakenInstitutions = () => {
    return this.unauthenticatedGet(`/reservation/request/unauth-user/institution`,
      {},
      {}
    );  
  }

  adminLoGetReservations = (role) => {
    role = encodeURIComponent(role).replace("(", "%28").replace(")", "%29")
    return this.get(`/reservation/listing-officer`,
      {
        role: role
      },
      {}
    )
  };

  adminLoApproveReservations = (id, adminListingOfficer) => {
    return this.post(`/reservation/listing-officer/approve`,
      {},
      {
        id: id,
        // listingDate: listingDate,
        adminListingOfficer: adminListingOfficer
      }
    )
  }

  adminLoRejectReservations = (id, adminListingOfficer, rejectReason) => {
    return this.post(`/reservation/listing-officer/reject`,
      {},
      {
        id: id,
        adminListingOfficer: adminListingOfficer,
        rejectReason: rejectReason
      }
    )
  }

  getBlockedDates = (role, institutionCode = undefined) => {
    role = encodeURIComponent(role);

    if (institutionCode === undefined) {
      return this.get('/block-dates', { 
        role: role 
        }, 
        {}
      );
    } else {
      return this.get('/block-dates', { 
        role: role,
        institutionCode: institutionCode
        }, 
        {}
      );
    }
  };

    adminLoBlockDates = (blockDateData) => {
      return this.post(`/reservation/listing-officer/date/block`,
        {},
        {
          blockDateData
        }
      )
    }

  adminLoUnblockDate = (id, reservationId = undefined, adminListingOfficer = undefined, reason = undefined) => {
    let payload;
    if (adminListingOfficer === undefined && reason === undefined && reservationId == undefined) {
      payload = { id };
    } else {
      payload = {
        dateId: id,
        reservationId,
        adminListingOfficer,
        reason
      };
    }
    return this.post(
      `/reservation/listing-officer/date/unblock`,
      {},
      payload
    );
  }

  issuerGetReservations = (institutionCode) => {
    return this.get(`/reservation/issuer`, {institutionCode}, {})
  }

  adcuGetReservations = (role) => {
    role = encodeURIComponent(role).replace("(", "%28").replace(")", "%29")
    return this.get(`/reservation/adcu`, 
      {
        role: role
      },
      {})
  }
}

export default ListingCalendarService;

// Author: Joshua Ian Española
// If any future devs work on the reports module(Which I made with the grace of the Lord Emperor, 
// power of Anime and braking down(not brakedancing), and no experience in AWS)
// and tried to "optimize" the reports api and fail, 
// please increment the counter as a warning to the next guy
//
// hours_wasted_here = 0
//
// If you successfully do it, congrats
// you are a heretic. HERESY
// How dare you tamper the work of the Omnissiah